import { render, staticRenderFns } from "./RadioBtn.vue?vue&type=template&id=00401a68&scoped=true&"
import script from "./RadioBtn.vue?vue&type=script&lang=js&"
export * from "./RadioBtn.vue?vue&type=script&lang=js&"
import style0 from "./RadioBtn.vue?vue&type=style&index=0&id=00401a68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00401a68",
  null
  
)

export default component.exports